/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    RouterStateSnapshot
} from '@angular/router';
import { UtenteService } from '@shared/services/utente.service';

@Injectable({
    providedIn: 'root'
})
export class CoreRuoloAmministratoreGuard implements CanActivate, CanActivateChild {

    constructor(
        private utenteService: UtenteService,
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.utenteService.isRuoloAmministratore();
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ) {
        return this.canActivate(next, state);
    }

}
